import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { EntranceDateSubForm } from '../subforms/EntranceDate';
import { PeriodSubForm, Schema as PeriodSchema } from '../subforms/Period';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformation';
import { DocumentsCertificatesSubForm, Schema as DocumentsCertificatesSchema } from '../subforms/DocumentsCertificates';

export const GundlachPraktikantenSchema = (settings) => (
    Yup.object()
        .concat(NameAndContactSchema(settings))
        .concat(PeriodSchema(settings))
        .concat(OtherInformationSchema(settings))
        .concat(DocumentsCertificatesSchema(settings))
);

export const GundlachPraktikanten = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={EntranceDateSubForm} colors={colors} settings={settings} />
            <Field component={PeriodSubForm} colors={colors} settings={settings} />
            <Field component={OtherInformationSubForm} colors={colors} settings={settings} />
            <Field component={DocumentsCertificatesSubForm} colors={colors} settings={settings} />
        </>
    );
}